import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/authentification/Login.css";
import "../styles/Landing.css";
import logoCirculumai from "../assets/brand/circulumai-logo.png";
import demoPreview from "../assets/demo-preview.png";

import logoDoctolib from "../assets/logos/doctolib.png";
import logoDanone from "../assets/logos/danone.png";
import logoMicrosoft from "../assets/logos/microsoft.png";
import logoZara from "../assets/logos/zara.png";
import logoLinkedin from "../assets/logos/linkedin.png";
import logoGithub from "../assets/logos/github.png";
import featuresPhoto from "../assets/team.png";

const TRUSTED_LOGOS = [
  { name: "Wiiisdom", src: logoGithub },
  { name: "Microsoft", src: logoMicrosoft },
  { name: "Zara", src: logoZara },
  { name: "Linkedin", src: logoLinkedin },
  { name: "DoctoLib", src: logoDoctolib },
  { name: "Danone", src: logoDanone },
];

export default function Landing() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  const [soonModal, setSoonModal] = useState({ open: false, label: "" });
  const openSoon = (label) => setSoonModal({ open: true, label });
  const closeSoon = () => setSoonModal({ open: false, label: "" });

  function handleSubmit(e) {
    e.preventDefault();
    alert("Merci ! Nous reviendrons vers vous rapidement.");
    setEmail("");
    setMsg("");
  }

  return (
    <div className="alx-root">
      <div className="alx-bg-img" aria-hidden="true" />
      <div className="alx-bg-scrim" aria-hidden="true" />

      <header className="alx-header">
        <a href="/" className="alx-brand" aria-label="CirculumAI – Accueil">
          <logoCirculumai />
          <span className="alx-brand-text is-desktop">CirculumAI</span>
          <span className="alx-brand-text is-mobile">CAI</span>
        </a>

        <nav className="alx-nav" aria-label="Navigation principale">
          <a className="alx-nav-link is-desktop" href="#features">Fonctionnalités</a>
          <a className="alx-nav-link is-desktop" href="#pricing">Tarifs</a>
          <a className="alx-nav-link is-desktop" href="#contact">Contact</a>

          <Link className="alx-nav-demo is-desktop" to="/demo" aria-label="Essayer la démo CirculumAI">
            Démo
          </Link>

          <Link className="alx-login is-desktop" to="/login" aria-label="Se connecter">
            Se connecter
          </Link>

          <a className="alx-nav-link is-mobile" href="#contact" aria-label="Contact">Contact</a>

          <Link className="alx-nav-demo is-mobile" to="/demo" aria-label="Démo">
            Démo
          </Link>

          <Link className="alx-login is-mobile" to="/login" aria-label="Connexion">
            Connexion
          </Link>
        </nav>
      </header>

      <section className="alx-hero">
        <div className="alx-hero-shade" aria-hidden="true" />

        <div className="alx-hero-inner">
          <h1 className="alx-hero-title">
            L’espace <span className="alx-accent">IA collaboratif</span> de votre équipe.
          </h1>
          <p className="alx-hero-sub">
            CirculumAI centralise vos conversations multi-LLM, vos jeux IA entre collègues
            et vos assistants métier. Un seul espace pour expérimenter, apprendre et
            déployer l’IA dans toute l’entreprise en toute sécurité.
          </p>

          <div className="alx-cta">
            <Link className="alx-btn alx-btn-primary" to="/login?signup=1">
              Démarrer gratuitement
            </Link>

            <Link className="alx-btn alx-btn-ghost" to="/demo">
              Voir la démo
            </Link>
          </div>

          <ul className="alx-kpis" aria-label="Indicateurs clés">
            <li>
              <strong>Multi-LLM</strong>
              <span>ChatGPT, Gemini et autres modèles</span>
            </li>
            <li>
              <strong>Jeux IA</strong>
              <span>Quiz & challenges entre collègues</span>
            </li>
            <li>
              <strong>Entreprise-ready</strong>
              <span>Workspaces, rôles & contrôles</span>
            </li>
          </ul>
        </div>

        <div className="alx-hero-bg" aria-hidden="true">
          <div className="alx-rings" />
        </div>
      </section>

      <section className="alx-trusted" aria-label="Clients de CirculumAI">
        <div className="alx-trusted-inner">
          <span className="alx-trusted-label">
            Fiable pour les équipes qui expérimentent l’IA :
          </span>

          <div className="alx-trusted-track">
            <div className="alx-trusted-row alx-trusted-logos">
              {TRUSTED_LOGOS.concat(TRUSTED_LOGOS).map((c, idx) => (
                <span className="alx-logo-pill" key={`${c.name}-${idx}`} title={c.name}>
                  <img
                    className="alx-logo-img"
                    src={c.src}
                    alt={c.name}
                    loading="lazy"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                      e.currentTarget.parentElement.classList.add("is-fallback");
                      e.currentTarget.parentElement.textContent = c.name;
                    }}
                  />
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="features" className="alx-section alx-features">
        <div className="alx-features-wrap">
          <div className="alx-features-left">
            <div className="alx-section-head alx-features-head">
              <h2>Tout ce qu’il faut pour adopter l’IA en interne</h2>
              <p>
                CirculumAI fournit un espace unique pour tester, déployer et partager des
                usages IA concrets dans votre entreprise.
              </p>
            </div>

            <div className="alx-grid alx-features-grid">
              <FeatureCard
                title="Chat multi-LLM"
                text="Créez des conversations IA en choisissant le moteur le plus adapté : ChatGPT, Gemini ou d’autres modèles. Changez de LLM en un clic dans la même discussion."
                icon={<IconCompass />}
              />
              <FeatureCard
                title="Jeux & quiz IA"
                text="Renforcez l’adoption de l’IA avec des quiz, défis et jeux entre collègues, générés et animés par les modèles IA."
                icon={<IconRadar />}
              />
              <FeatureCard
                title="Assistants métier"
                text="Configurez des assistants IA sur vos cas d’usage : support interne, aide au code, résumé de documents, préparation d’entretiens, et plus."
                icon={<IconReport />}
              />
              <FeatureCard
                title="Contrôle & sécurité"
                text="Gérez les accès par équipes, définissez des espaces, suivez l’usage et gardez la maîtrise de vos données et de vos appels aux LLM."
                icon={<IconPlug />}
              />
            </div>
          </div>

          <aside className="alx-features-right" aria-label="Aperçu visuel CirculumAI">
            <div className="alx-features-visual">
              <img
                className="alx-features-photo"
                src={featuresPhoto}
                alt="Aperçu de CirculumAI : workspace, chat multi-LLM et gouvernance"
                loading="lazy"
              />

              <div className="alx-features-visual-caption">
                <strong>Un workspace IA prêt pour l’entreprise</strong>
                <span>Multi-LLM, assistants métier & contrôle des accès.</span>
              </div>
            </div>
          </aside>
        </div>
      </section>

      <section id="demo" className="alx-demo">
        <div className="alx-demo-card">
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
            <h3 style={{ margin: 0 }}>CirculumAI en action</h3>
            <span className="alx-badge alx-badge-soon">Mode démo</span>
          </div>
          <p>
            Essayez CirculumAI sans créer de compte : espace de test, jeux IA de démonstration
            et exemples d’assistants métier déjà configurés.
          </p>

          <Link
            to="/demo"
            className="alx-demo-preview"
            aria-label="Ouvrir la démo CirculumAI"
          >
            <img
              className="alx-demo-preview-img"
              src={demoPreview}
              alt="Aperçu de la démo CirculumAI"
              loading="lazy"
            />
            <div className="alx-demo-preview-overlay">
              <span className="alx-demo-preview-badge">Voir la démo</span>
            </div>
          </Link>

          <div className="alx-cta">
            <Link className="alx-btn alx-btn-primary" to="/demo">
              Accéder à la démo
            </Link>
            <a className="alx-btn alx-btn-ghost" href="#pricing">
              Consulter les tarifs
            </a>
          </div>
        </div>
      </section>

      <section id="pricing" className="alx-section">
        <div className="alx-section-head">
          <h2>Une tarification adaptée aux PME</h2>
          <p>
            Démarrez avec une équipe pilote, puis étendez CirculumAI à toute l’entreprise
            quand les usages sont validés.
          </p>
        </div>

        <div className="alx-pricing">
          <PriceCard
            badge="Starter"
            price="€39"
            per="/mois"
            items={["5 utilisateurs", "Chat multi-LLM", "Jeux IA de base", "Support par e-mail"]}
          />
          <PriceCard
            badge="Team"
            highlight
            price="€99"
            per="/mois"
            items={[
              "20 utilisateurs",
              "Workspaces d’équipes",
              "Jeux & quiz illimités",
              "Assistants métier configurables",
            ]}
          />
          <PriceCard
            badge="Entreprise"
            price="Sur devis"
            per=""
            items={[
              "Nombre d’utilisateurs illimité",
              "Intégrations SSO & API",
              "Contrôle avancé des données",
              "Accompagnement dédié",
            ]}
          />
        </div>
      </section>

      <section id="contact" className="alx-section alx-contact">
        <div className="alx-section-head">
          <h2>Parlons de votre projet IA</h2>
          <p>
            Expliquez-nous vos cas d’usage (support, code, RH, formation…) et nous
            vous montrerons comment les mettre en place dans CirculumAI.
          </p>
        </div>

        <div className="alx-contact-grid">
          <form className="alx-form" onSubmit={handleSubmit}>
            <label className="alx-label">
              Email
              <input
                type="email"
                required
                placeholder="vous@entreprise.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="alx-input"
              />
            </label>

            <label className="alx-label">
              Message
              <textarea
                required
                rows={5}
                placeholder="Décrivez votre besoin ou vos questions…"
                value={msg}
                onChange={(e) => setMsg(e.target.value)}
                className="alx-textarea"
              />
            </label>

            <button className="alx-btn alx-btn-primary" type="submit">
              Envoyer
            </button>
          </form>

          <aside className="alx-aside">
            <h3>Nos coordonnées</h3>
            <ul className="alx-list">
              <li>📧 contact@circulumai.com</li>
              <li>📞 +212 6 98 22 75 19</li>
              <li>🕓 Lun–Ven · 9h–18h CET</li>
            </ul>

            <div className="alx-socials" aria-label="Réseaux sociaux">
              <a
                href="https://x.com/"
                aria-label="X / Twitter"
                className="alx-social"
                onClick={(e) => {
                  e.preventDefault();
                  openSoon("X / Twitter");
                }}
              >
                <IconX />
              </a>
              <a
                href="https://www.linkedin.com/"
                aria-label="LinkedIn"
                className="alx-social"
                onClick={(e) => {
                  e.preventDefault();
                  openSoon("LinkedIn");
                }}
              >
                <IconLinkedIn />
              </a>
              <a
                href="https://www.youtube.com/"
                aria-label="YouTube"
                className="alx-social"
                onClick={(e) => {
                  e.preventDefault();
                  openSoon("YouTube");
                }}
              >
                <IconYouTube />
              </a>
              <a
                href="https://www.instagram.com/"
                aria-label="Instagram"
                className="alx-social"
                onClick={(e) => {
                  e.preventDefault();
                  openSoon("Instagram");
                }}
              >
                <IconInstagram />
              </a>
            </div>
          </aside>
        </div>
      </section>

      <footer className="alx-footer">
        <div className="alx-footer-inner">
          <div className="alx-footer-brand">
            <span>CirculumAI</span>
          </div>
          <nav className="alx-footer-nav" aria-label="Liens légaux">
            <a
              href="/legal/terms"
              onClick={(e) => {
                e.preventDefault();
                openSoon("Conditions d’utilisation");
              }}
            >
              Conditions
            </a>
            <a
              href="/legal/privacy"
              onClick={(e) => {
                e.preventDefault();
                openSoon("Politique de confidentialité");
              }}
            >
              Confidentialité
            </a>
            <a
              href="/legal/security"
              onClick={(e) => {
                e.preventDefault();
                openSoon("Sécurité");
              }}
            >
              Sécurité
            </a>
          </nav>
          <span className="alx-footnote">
            © {new Date().getFullYear()} CirculumAI. Tous droits réservés.
          </span>
        </div>
      </footer>

      {soonModal.open && (
        <div className="arena-modal" role="dialog" aria-modal="true" aria-labelledby="soon-title">
          <div className="arena-modal-box">
            <h3 id="soon-title">{soonModal.label}</h3>
            <p>Cette page sera disponible très bientôt. Merci pour votre patience ! 🚧</p>
            <button className="arena-primary arena-modal-close" onClick={closeSoon}>
              OK
            </button>
          </div>
          <button className="arena-modal-backdrop" aria-label="Fermer" onClick={closeSoon} />
        </div>
      )}
    </div>
  );
}

function FeatureCard({ title, text, icon }) {
  return (
    <article className="alx-card">
      <div className="alx-card-icon">{icon}</div>
      <h3>{title}</h3>
      <p>{text}</p>
    </article>
  );
}

function PriceCard({ badge, price, per, items, highlight }) {
  return (
    <article className={`alx-price ${highlight ? "is-highlight" : ""}`} aria-label={`Offre ${badge}`}>
      <div className="alx-price-badge">{badge}</div>
      <div className="alx-price-amount">
        <span className="alx-price-number">{price}</span>
        <span className="alx-price-per">{per}</span>
      </div>
      <ul className="alx-price-list">
        {items.map((it) => (
          <li key={it}>{it}</li>
        ))}
      </ul>
      <Link className="alx-btn alx-btn-primary alx-price-cta" to="/login?signup=1">
        Commencer
      </Link>
    </article>
  );
}

function LogoCirculumAI() {
  return (
    <svg className="alx-logo" viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <linearGradient id="alx-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#0ea5e9" />
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="24" fill="url(#alx-grad)" opacity="0.18" />
      <path d="M32 10l15 26H17L32 10z" fill="url(#alx-grad)" />
      <path d="M24 36h16l-8 14-8-14z" fill="#0f172a" opacity="0.9" />
    </svg>
  );
}

function IconCompass() {
  return (
    <svg viewBox="0 0 24 24" className="alx-ico" aria-hidden="true">
      <path d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2Zm4 4-3 7-7 3 3-7 7-3Z" />
    </svg>
  );
}
function IconRadar() {
  return (
    <svg viewBox="0 0 24 24" className="alx-ico" aria-hidden="true">
      <path d="M12 3a9 9 0 1 0 9 9h-2a7 7 0 1 1-7-7V3z" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  );
}
function IconReport() {
  return (
    <svg viewBox="0 0 24 24" className="alx-ico" aria-hidden="true">
      <path d="M6 3h9l5 5v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" />
      <path d="M14 3v5h5" />
      <path d="M8 12h8M8 16h6" />
    </svg>
  );
}
function IconPlug() {
  return (
    <svg viewBox="0 0 24 24" className="alx-ico" aria-hidden="true">
      <path d="M7 2v6M17 2v6" />
      <path d="M3 8h18v3a7 7 0 1 1-14 0V8Z" />
    </svg>
  );
}

function IconX() {
  return (
    <svg viewBox="0 0 24 24" className="alx-ico" aria-hidden="true">
      <path d="M4 4l16 16M20 4 4 20" />
    </svg>
  );
}
function IconLinkedIn() {
  return (
    <svg viewBox="0 0 24 24" className="alx-ico" aria-hidden="true">
      <path d="M4 4h4v16H4zM9 9h4v11H9zM14 9h4v11h-4z" />
      <circle cx="6" cy="6" r="2" />
    </svg>
  );
}
function IconYouTube() {
  return (
    <svg viewBox="0 0 24 24" className="alx-ico" aria-hidden="true">
      <path d="M22 12s0-5-1-6-3-1-9-1-8 0-9 1-1 6-1 6 0 5 1 6 3 1 9 1 8 0 9-1 1-6 1-6Z" />
      <path d="M10 15V9l6 3-6 3z" />
    </svg>
  );
}
function IconInstagram() {
  return (
    <svg viewBox="0 0 24 24" className="alx-ico" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17" cy="7" r="1.2" />
    </svg>
  );
}